/**
 * MUI createTheme palette values — hex literals that MUI's alpha() utility
 * can decompose.  CSS variables (e.g. `var(--token, #000)`) break MUI
 * internals, so we keep raw hex values here in the design-system layer.
 *
 * Consumers import these via the design-system barrel so they never have to
 * hardcode hex colors themselves.
 */

export interface PaletteEntry {
  background: { default: string; paper: string };
  text: { primary: string; secondary: string };
  divider: string;
  action: { active: string; hover: string; selected: string; disabled: string; disabledBackground: string };
}

export const lightPalette: PaletteEntry = {
  background: { default: "#f5f5f5", paper: "#ffffff" },
  text: { primary: "#000000", secondary: "#64748B" },
  divider: "#E2E8F0",
  action: {
    active: "rgba(0, 0, 0, 0.54)",
    hover: "rgba(0, 0, 0, 0.04)",
    selected: "rgba(0, 0, 0, 0.08)",
    disabled: "rgba(0, 0, 0, 0.26)",
    disabledBackground: "rgba(0, 0, 0, 0.12)",
  },
};

export const darkPalette: PaletteEntry = {
  background: { default: "#121212", paper: "#1e1e1e" },
  text: { primary: "#ffffff", secondary: "#94A3B8" },
  divider: "#334155",
  action: {
    active: "rgba(255, 255, 255, 0.7)",
    hover: "rgba(255, 255, 255, 0.08)",
    selected: "rgba(255, 255, 255, 0.12)",
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
  },
};
